import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaCode, FaGithub, FaLinkedin, FaTwitter } from 'react-icons/fa';
import { theme } from '../../theme';
import {
  FooterWrapper,
  Container,
  TopRow,
  BrandCol,
  FooterLogo,
  FooterDesc,
  SocialRow,
  SocialBtn,
  LinkCol,
  ColTitle,
  FooterLinks,
  FooterLink,
  FooterExtLink,
  Divider,
  BottomRow,
  Copyright,
  BottomLinks,
} from './Footer.styles';

const Footer: React.FC = () => {
  const { t } = useTranslation();
  const year = new Date().getFullYear();

  return (
    <FooterWrapper>
      <Container>
        <TopRow>
          <BrandCol>
            <FooterLogo to="/">
              <FaCode size={18} style={{ color: theme.colors.primary }} />
              <span>ERCOMP</span>
            </FooterLogo>
            <FooterDesc>{t('footer.desc')}</FooterDesc>
            <SocialRow>
              <SocialBtn href="https://github.com" target="_blank" rel="noopener noreferrer" aria-label="GitHub">
                <FaGithub />
              </SocialBtn>
              <SocialBtn href="https://linkedin.com" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                <FaLinkedin />
              </SocialBtn>
              <SocialBtn href="https://twitter.com" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
                <FaTwitter />
              </SocialBtn>
            </SocialRow>
          </BrandCol>

          <LinkCol>
            <ColTitle>{t('footer.navTitle')}</ColTitle>
            <FooterLinks>
              <li><FooterLink to="/">{t('footer.navHome')}</FooterLink></li>
              <li><FooterLink to="/uslugi">{t('footer.navServices')}</FooterLink></li>
              <li><FooterLink to="/portfolio">{t('footer.navPortfolio')}</FooterLink></li>
              <li><FooterLink to="/kontakt">{t('footer.navContact')}</FooterLink></li>
            </FooterLinks>
          </LinkCol>

          <LinkCol>
            <ColTitle>{t('footer.servicesTitle')}</ColTitle>
            <FooterLinks>
              <li><FooterLink to="/uslugi">{t('footer.svcWeb')}</FooterLink></li>
              <li><FooterLink to="/uslugi">{t('footer.svcPwa')}</FooterLink></li>
              <li><FooterLink to="/uslugi">{t('footer.svcExpo')}</FooterLink></li>
              <li><FooterLink to="/uslugi">{t('footer.svcWebapp')}</FooterLink></li>
            </FooterLinks>
          </LinkCol>

          <LinkCol>
            <ColTitle>{t('footer.techTitle')}</ColTitle>
            <FooterLinks>
              <li><FooterExtLink href="https://reactjs.org" target="_blank" rel="noopener noreferrer">React &amp; TypeScript</FooterExtLink></li>
              <li><FooterExtLink href="https://nextjs.org" target="_blank" rel="noopener noreferrer">Next.js</FooterExtLink></li>
              <li><FooterExtLink href="https://reactnative.dev" target="_blank" rel="noopener noreferrer">React Native</FooterExtLink></li>
              <li><FooterExtLink href="https://expo.dev" target="_blank" rel="noopener noreferrer">Expo SDK</FooterExtLink></li>
            </FooterLinks>
          </LinkCol>
        </TopRow>

        <Divider />

        <BottomRow>
          <Copyright>
            © {year} <span>ER COMP</span>. {t('footer.copyright')}
          </Copyright>
          <BottomLinks>
            <a href="/polityka-prywatnosci">{t('footer.privacy')}</a>
            <a href="/regulamin">{t('footer.terms')}</a>
          </BottomLinks>
        </BottomRow>
      </Container>
    </FooterWrapper>
  );
};

export default Footer;
